import { useEffect } from "react";

function preloadImages (src: string) {
    const img = new Image()
    img.src = src
}

export function usePreloadImages (images: string[]) {
    useEffect(() => {
        images.forEach(preloadImages)
    }, [images])
}